import 'zone.js';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { appConfig } from './app.config';
import * as Sentry from '@sentry/angular';
import { environment } from './environments/environment';

// Initialize Sentry if enabled
if (environment.sentry.enabled) {
  Sentry.init({
    dsn: environment.sentry.dsn,
    environment: environment.production ? 'production' : 'development',
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    // Capture 100% of transactions, adjust in production if needed
    tracesSampleRate: 1.0,
    // Set propagation targets to your backend domain
    tracePropagationTargets: ['localhost', 'http://localhost:3000'],
    // Capture 100% of sessions with errors, and 10% of all other sessions
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
  });
}

bootstrapApplication(AppComponent, appConfig)
  .catch((err: any) => console.error(err));